export const LANGUAGE_KEY = "@GESTCORRETORLANGUAGE";

export const getLanguage = () => {
  return localStorage.getItem(LANGUAGE_KEY);
};

export const setLanguage = (language) => {
  localStorage.setItem(LANGUAGE_KEY, language);
};

/**
 * Load all JSON translation files for the requested language and
 * return a flat object where keys are full paths like:
 * "clients.modals.create.form.name" -> "Nome"
 */
export const loadTranslations = async (lang) => {
  try {
    const context = require.context("../translations", true, /\.json$/);
    const translations = {};

    context.keys().forEach((key) => {
      // only pick files that end with /<lang>.json
      if (key.endsWith(`/${lang}.json`) || key.endsWith(`${lang}.json`)) {
        // key example: "./clients/modals/create/pt.json"
        const pathParts = key.replace("./", "").split("/"); // ["clients","modals","create","pt.json"]
        const namespaceParts = pathParts.slice(0, -1); // ["clients","modals","create"]
        const namespace = namespaceParts.join("."); // "clients.modals.create"

        const fileData = context(key); // object loaded from JSON

        // Flatten nested fileData into translations with prefix namespace
        const flatten = (obj, parentKey = "") => {
          Object.keys(obj).forEach((k) => {
            const value = obj[k];
            const newKey = parentKey ? `${parentKey}.${k}` : k;
            if (value && typeof value === "object" && !Array.isArray(value)) {
              // recurse
              flatten(value, newKey);
            } else {
              // final value — store with full namespace prefix
              translations[`${namespace}.${newKey}`] = value;
            }
          });
        };

        flatten(fileData);
      }
    });

    return translations;
  } catch (error) {
    console.error("Erro ao carregar traduções:", error);
    return {};
  }
};
